import React from "react";

import DataList from "./DataTableList";

import MainButton from "../../../common/MainButton";

import lbl from "../../../../data/Labels.json";
import MainDatePicker from "../../../common/MainDatePicker";
import DailyReportBalance from "./DailyReportBalance";
import MainPrintLink from "../../../common/MainPrint";
import PrintReportIcon from "../../../../icons/print-report";

const DataTable = ({
  transactionPrintPath,
  balancePrintPath,
  handleDateChange,
  selectedDate,
  currentTab,
  summary,
  data,
  type,
}) => {
  return (
    <div className="report-router">
      <div className="report-router-head">
        <div className="head-left">
          <MainPrintLink path={balancePrintPath} />
          <MainPrintLink
            path={transactionPrintPath}
            icon={<PrintReportIcon />}
          />
          <MainButton title={lbl.Excel} type={"excel"} />
          <MainDatePicker handleChange={handleDateChange} />
        </div>
        <div className="head-right">
          <p>
            {currentTab?.name || lbl.OverallBalance} {selectedDate}
          </p>
        </div>
      </div>
      <div className="data-table">
        {currentTab ? (
          <DataList
            data={data}
            currentTab={currentTab}
            type={type}
            summary={summary}
          />
        ) : (
          <DailyReportBalance summary={summary} />
        )}
      </div>
    </div>
  );
};

export default DataTable;
